
import { ref } from "vue";

export default({
    name:"changePassword",
    props:['baseUrl', 'userId'],
    setup(props:any){
        const oldPassword = ref('');
        const newPassword = ref('');
        const confirmPassword = ref('');
        const isPasswordChangeSuccessful = ref('');

        const changePassword = ()=>{
            isPasswordChangeSuccessful.value = '';
            //console.log("props.baseUrl " , props.baseUrl);
            //console.log("props.userId " , props.userId);


            if(newPassword.value != confirmPassword.value)
            {
                alert("Enter new-password does not match the confirm-password. Please enter same password in both places.");
                return;
            }
            let token = localStorage.getItem("Guardtoken");
            //console.log("token ", token);
            let userLoginId = localStorage.getItem("UserLoginId") as string;
            //console.log("userLoginId ", userLoginId);

            let requestUrl = props.baseUrl + "login/ChangeGuardUserPassword";
            let requestContents={
                method:"POST",
                headers:{
                    "Content-Type":"application/json",
                    "Authorization":`Bearer ${token}`
                },
                body: JSON.stringify({
                    NewPassword:newPassword.value,
                    UserPb : {
                        UserId: parseInt(userLoginId),// props.userId,
                        Password : oldPassword.value,
                        UserName:"ABAD"
                    },
                }),
            };
            fetch(requestUrl, requestContents)
            .then(response => {
                let res = response.json();
                //console.log("res ", res);
                return res;
            })
            .then( res => {
                //console.log("res " , res);
                if(res.loginResultUserViewModel == null)
                    isPasswordChangeSuccessful.value = 'false';
                else
                    isPasswordChangeSuccessful.value = 'true';
            });
        }

        return{
            oldPassword,
            newPassword,
            confirmPassword,
            isPasswordChangeSuccessful,
            changePassword
        }
    },
});
